module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/243.64f9ad09.png";